module.exports = __webpack_public_path__ + "static/media/who_back_bg.c9897800.png";